import { IRequestWithCallBack } from '../../../Hooks/useRequest';
import { IUserCreation } from '../models/userCreation.models';
import { Dispatch, SetStateAction } from 'react';
import { IErrorResponse } from '../../../Models/DTO/Error.models';
import { createANewProvider, createANewUser, createANewOrganisation } from './APIs';
import { Segment } from '../../../Helpers/Segment.helper';
import { IProviderCreation } from '../models/providerCreation.models';
import IUser from '../../../Models/DTO/User.model';
import { Provider, OrganisationAccessType } from '~/Models/DTO/Provider.model';
import { IOrganisation } from '~/Models/DTO/Organisation.model';
const setSegmentData = (user: IUserCreation | IUser, provider: Provider) => {
  const firstname =
    (user as IUserCreation).new_user?.first_name || (user as IUser).first_name || '';
  const lastname = (user as IUserCreation).new_user?.last_name || (user as IUser).last_name || '';
  Segment.identify(provider.email, {
    provider_id: provider.uuid,
    email: provider.email,
    country: provider.address?.country,
    providerCountry: provider.address?.country,
    vertical: provider.providerCategory?.slug,
    company: provider.name,
    firstname,
    lastname,
    isUSCMember: provider.isUSCMember ? 'true' : 'false',
    isOneFitMember: provider.isOneFitMember ? 'true' : 'false',
    signupSource: 'Neo',
  });
  const pathName = location.pathname ? location.pathname.split('/').pop() : '';
  Segment.pageview(pathName || '', location.href);
};

export const createAProviderAccount = (
  request: IRequestWithCallBack,
  userData: IUserCreation | IUser,
  providerData: IProviderCreation,
  setData: () => void,
  setError: Dispatch<SetStateAction<IErrorResponse>>,
  access_token?: string,
) => {
  function setOrganisationData(callback: (data: any) => void) {
    createANewOrganisation(
      request,
      {
        domain: providerData.slug,
        email: providerData.email,
        name: providerData.name,
        logoUrl: '',
        logoOriginalUrl: '',
        accessType: OrganisationAccessType.FULL,
      } as IOrganisation,
      (organization) => callback(organization),
      (error) => setError(error),
    );
  }
  setOrganisationData((organizationData) => {
    createANewProvider(
      request,
      { ...providerData, organisationId: organizationData.id },
      (data: { provider: Provider }) => {
        setSegmentData(userData, data.provider);
        // TODO we have to make sure Core service has created everything for the provider.
        setData();
      },
      (error) => setError(error),
      access_token,
    );
  });
};

export const createAProviderPostLogin = (
  request: IRequestWithCallBack,
  providerData: IProviderCreation,
  setData: (providerCreation: { provider: Provider }) => void,
  setError: Dispatch<SetStateAction<IErrorResponse>>,
  access_token?: string,
) => {
  function setOrganisationData(callback: (data: any) => void) {
    createANewOrganisation(
      request,
      {
        domain: providerData.slug,
        email: providerData.email,
        name: providerData.name,
        logoUrl: '',
        logoOriginalUrl: '',
        accessType:
          providerData.isOneFitMember || providerData.isUSCMember
            ? OrganisationAccessType.PARTNER_TOOL
            : OrganisationAccessType.FULL,
      } as IOrganisation,
      (organization) => callback(organization),
      (error) => setError(error),
    );
  }
  setOrganisationData((organizationData) => {
    createANewProvider(
      request,
      { ...providerData, organisationId: organizationData?.id },
      setData,
      (error) => setError(error),
      access_token,
    );
  });
};

export const createAUserAndProvider = (
  request: IRequestWithCallBack,
  userData: IUserCreation,
  providerData: IProviderCreation,
  loggedInUserData: IUser | undefined,
  setData: () => void,
  setError: Dispatch<SetStateAction<IErrorResponse>>,
) => {
  if (!loggedInUserData) {
    createANewUser(
      request,
      userData,
      () => {
        createAProviderAccount(request, userData, providerData, setData, setError);
      },
      (error) => setError(error),
    );
  }
};
